import React from 'react';
import TopPanel from "./toppanel.js";

module.exports = React.createClass({
    success: function(reply) {
        if (!this.mountState)
            return;
        this.setState({data: reply.data});
    },


    getInitialState: function () {
        return {
            data: []
        }
    },

    componentDidMount: function () {
        this.mountState = true;
        HC_RestoreNavPanel();
        HC_SelectNavItem("li-feedback");
        HC_SendRequest("get_feedback", null, this.success);
        HC_SubscribeHammerEvent(this.refs.feedback, "swiperight", HC_ToggleNavPanel);
    },
    componentWillUnmount: function () {
        this.mountState = false;
        HC_UnsubscribeHammerEvent(this.refs.feedback, "swiperight");
    },

    render: function () {

        var items = this.state.data;
        if (items === null || items === undefined) {
            items = [];
        }

        var listItems = items.map(function (o) {
            var attach;
            if (o.file_name && o.file_name.length > 0) {
                var link = HC_GetSiteAddr() + "download_feedback/" + o.file_name.split('/')[0];
                attach = (<a className="hc-f4 " href={link} style={{ marginTop:"0.5rem", width: "100%", color:"blue", display:'inline-block', textDecoration:"underline"}}>Download attachment</a>);
            }
            return (
                <div data-key={o.id} key={o.id} style={{padding: "2%", margin:"2%", border: "1px solid #E6EAED", whiteSpace: "normal"}}>

                    <div style={{textAlign:"left", padding:"1%", width: "100%" }}>
                        <div className="hc-f4" style={{marginBottom:"0.5rem"}}>{'#' + o.number + '  ' + o.type + ', ' + HC_FormatDateFull(o.date)}</div>
                        <div className="hc-f4" style={{ marginTop:"0.5rem"}}>{o.user_name + ' (' + o.user_login + ') '} </div>
                        <div className="hc-f4 " style={{ marginTop:"0.5rem", overflowWrap: "break-word"}}>{o.text}</div>
                        {attach}
                    </div>
                </div>
            );
        }.bind(this));

        return (
            <div style={{position:'relative', width:'100%', height:'100%'}}>

                <TopPanel text={HC_LANG.NAV_FEEDBACK} licon="fa-bars" onLiconClick={HC_ToggleNavPanel}/>

                <div ref="feedback" style={{padding:"1rem", position:"absolute", left:0, right:0, top:"60px", bottom:0, overflowY: "auto", WebkitOverflowScrolling:'touch'}}>
                    {listItems}</div>
            </div>
        );
    }
});


// WEBPACK FOOTER //
// ./viewfeedback.js